import { render, staticRenderFns } from "./Parametri.vue?vue&type=template&id=5b5ed77c&"
import script from "./Parametri.vue?vue&type=script&lang=js&"
export * from "./Parametri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports